import { motion } from "framer-motion";
import { Link } from "react-router-dom";

/**
 * Homepage quick-access band — points guests to Travel (directions/parking)
 * and Where to Stay (partner hotel rates). Lightweight by design.
 */
const TravelQuickAccess = () => {
  return (
    <section className="bg-yacht-cream px-6 py-20 md:px-16 md:py-28">
      <div className="mx-auto grid max-w-6xl items-center gap-10 md:grid-cols-2 md:gap-16">
        {/* Visual */}
        <motion.div
          className="relative order-2 aspect-[4/3] overflow-hidden rounded-2xl shadow-xl md:order-1"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <img
            src="/hotels/siren-candy-bar.webp"
            alt="The Siren Hotel Detroit — a Yacht Rock Detroit partner hotel"
            loading="lazy"
            className="h-full w-full object-cover"
          />
          <span className="absolute left-4 top-4 inline-flex items-center rounded-full bg-yacht-yellow px-4 py-1.5 text-sm font-bold uppercase tracking-wide text-yacht-charcoal shadow-lg">
            20% Off Hotel Rates
          </span>
        </motion.div>

        {/* Copy + links */}
        <motion.div
          className="order-1 md:order-2"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.3em] text-yacht-blue">
            Plan Your Weekend
          </p>
          <h2 className="text-4xl font-bold leading-[0.95] tracking-tight text-yacht-charcoal md:text-5xl">
            Travel &amp; Where to Stay
          </h2>
          <p
            className="mt-5 max-w-md text-lg leading-relaxed text-yacht-charcoal/70"
            style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
          >
            Directions, parking, and exclusive rates at partner hotels — including
            20% off at The Siren. Everything you need to make a weekend of it on
            the Detroit River.
          </p>

          <div className="mt-8 flex flex-col gap-4 sm:flex-row">
            <Link
              to="/travel"
              className="inline-flex items-center justify-center rounded-full bg-yacht-blue px-8 py-4 text-base font-bold text-white shadow-lg transition-transform hover:scale-[1.03] hover:bg-yacht-blue/90"
            >
              Travel &amp; Directions
            </Link>
            <Link
              to="/travel#hotels"
              className="inline-flex items-center justify-center rounded-full border-2 border-yacht-charcoal/15 bg-white px-8 py-4 text-base font-bold text-yacht-charcoal transition-transform hover:scale-[1.03] hover:border-yacht-blue"
            >
              Where to Stay →
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TravelQuickAccess;
